module.exports = __webpack_public_path__ + "static/media/send.e008261d.svg";